import initOrderHistory from './orders';
import initAddresses from './addresses';

export default () => {
  initOrderHistory();
  initAddresses();

  document.addEventListener('change', (e) => {
    const target = e.target;
    if (target && target.matches('[data-account-nav-mobile]')) {
      const selected_value = target.value;

      if (selected_value.charAt(0) === '/') {
        window.location.href = selected_value;
      } else if (selected_value.includes('http')) {
        window.open(selected_value, '_blank');
      } else if (selected_value === 'chat') {
        if (typeof window.Gladly !== 'undefined') {
          const chatContainer = document.getElementById('gladlyChat_container');
          if (chatContainer) chatContainer.classList.add('visible');
          if (typeof window.Gladly !== 'undefined') {
            window.Gladly.show();
          }
        }
      }
    }
  });
};
